module.exports = __webpack_public_path__ + "img/ill-home-skills-high-quality.88a171c9.svg";